import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { Sc3FailedMessagesListState, Sc3FailedMessagesListStateModel } from './sc3-failed-messages-list.state';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../list-search-criteria';
import { Sc3FailedMessagesListSearchCriteria, Sc3FailedMessagesModel } from '../../models';
import { Sc3FailedMessagesListInitialState, Sc3FailedMessagesListLoad } from './sc3-failed-messages-list.actions';
import { FailedMessagesListFacadeInterface } from '../../models/failed-messages-facades.model';

@Injectable({ providedIn: 'root' })
export class Sc3FailedMessagesListFacade implements FailedMessagesListFacadeInterface<Sc3FailedMessagesModel> {
  listDto$: Observable<Sc3FailedMessagesListStateModel> = this.store.select(Sc3FailedMessagesListState.getState);
  items$: Observable<Sc3FailedMessagesModel[]> = this.store.select(Sc3FailedMessagesListState.getItems);
  totalElements$: Observable<number> = this.store.select(Sc3FailedMessagesListState.getTotalElements);
  loaded$: Observable<boolean> = this.store.select(Sc3FailedMessagesListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Sc3FailedMessages)
      .subscribe((searchCriteria: Sc3FailedMessagesListSearchCriteria) => {
        this.store.dispatch(new Sc3FailedMessagesListLoad(searchCriteria));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new Sc3FailedMessagesListInitialState());
  }
}
